import { CollectionTypes } from '~/types/adamTypes';

export const getDBContentCollectionsWithAssociatedItems =
  (): CollectionTypes[] => {
    return [
      CollectionTypes.Categories,
      CollectionTypes.Posts,
      CollectionTypes.Media,
      CollectionTypes.Exercises,
      CollectionTypes.ExerciseItems,
    ];
  };

export const getDBContentCollections = (): CollectionTypes[] => {
  return [
    CollectionTypes.Categories,
    CollectionTypes.Posts,
    CollectionTypes.Media,
    CollectionTypes.Exercises,
  ];
};
